import { AccountingRequestItem } from './types';

export const ACTIVE_CODAT_STATUS: AccountingRequestItem['codatStatus'] =
  'request';
